import { Record } from "immutable";

const Player = Record({ shortName: null, longName: null });
export default Player;



// WEBPACK FOOTER //
// ./src/Player.js